import { KeyValue } from '@angular/common';

/*
 * Original key insertion ordering function, for use with Angular's keyvalue pipe.
 * Returns constant 0 to tell Angular to maintain original key order.
 *
 * Use with Maps or Objects. ES6+ guarantees original insertion order for object string keys.
*/
export const keyInsertionOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): 0 => 0;
